<template>
  <div
    :class="['set-box', isDisplay ? 'isDisplay' : '']"
    :style="{ background: hasBack }"
  >
    <p
      :class="{ zan: true, cancelzan: item.is_liked === 0 }"
      @click="handleZan(item.id)"
    >
      <span class="set-num">{{ item.like_num }}</span>
      <span>点赞</span>
    </p>
    <p
      :class="{ collect: true, cancelCollect: item.is_collected }"
      @click="handleCollect(item.id, item.is_collected)"
      v-if="isCollect"
    >
      <span>收藏</span>
    </p>
    <p class="comment" @click="handleComment(item, index)">
      <span class="set-num">{{ item.comment_num }}</span>
      <span>评论</span>
    </p>
    <p class="browse">
      <span class="set-num">{{ item.click_num }}</span>
      <span>浏览</span>
    </p>
    <div class="more" v-if="showComplaint && isShowDel">
      <p class="dot" @click="showBtn">···</p>
      <p
        class="delandreport"
        v-if="
          ishowBtn &&
          $store.state.user_info.id != item.user_id &&
          $identity.name == 'student'
        "
        @click="onComplaint(item.id)"
      >
        举报
      </p>
      <p
        class="delandreport"
        v-if="ishowBtn && $store.state.user_info.id == item.user_id"
        @click="onDelete(item.id)"
      >
        删除
      </p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: 0,
    },
    isCollect: {
      type: Boolean,
      default: false,
    },
    hasBack: {
      type: String,
      default: "#f7f7f7",
    },
    isDisplay: {
      type: Boolean,
      default: false,
    },
    isShowDel: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showComplaint() {
      if (this.$store.state.user_info.id == this.item.user_id) {
        return true;
      }
      if (
        this.$store.state.user_info.id != this.item.user_id &&
        this.$identity.name == "student"
      ) {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      ishowBtn: false,
    };
  },
  methods: {
    handleZan(id) {
      this.$emit("handleZan", id);
      this.$emit("refresh");
    },
    handleComment(item, index) {
      this.$emit("handleComment", item, index);
    },
    handleCollect(id, is_collected) {
      this.$emit("handleCollect", id, is_collected);
    },
    showBtn() {
      this.ishowBtn = !this.ishowBtn;
    },
    onDelete(id) {
      this.$emit("onDelete", id);
      this.ishowBtn = false;
    },
    onComplaint(id) {
      this.$emit("onComplaint", id);
      this.ishowBtn = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.set-box {
  margin-top: 20px;
  line-height: 40px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-radius: 4px;
  p {
    font-size: 14px;
    color: #666;
    .set-num {
      margin: 0 5px;
    }
  }
  .zan {
    display: inline-block;
    padding-left: 20px;
    background: url("~@/assets/images/icon_fourm_zan.png") left no-repeat;
    background-size: 20px 20px;
    cursor: pointer;
  }
  .cancelzan {
    background: url("~@/assets/images/icon_fourm_cancleZan.png") left no-repeat;
    background-size: 20px 20px;
    cursor: pointer;
  }
  .collect {
    display: inline-block;
    padding-left: 24px;
    background: url("~@/assets/images/icon-collect.png") left no-repeat;
    background-size: 20px 20px;
    cursor: pointer;
  }
  .cancelCollect {
    background: url("~@/assets/images/icon-collected.png") left no-repeat;
    background-size: 20px 20px;
    cursor: pointer;
  }
  .comment {
    display: inline-block;
    padding-left: 21px;
    background: url("~@/assets/images/icon_fourm_comment.png") left center
      no-repeat;
    background-size: 20px 20px;
    cursor: pointer;
  }
  .browse {
    display: inline-block;
    padding-left: 20px;
    background: url("~@/assets/images/icon_fourm_browse.png") left no-repeat;
    background-size: 20px 20px;
  }
  .more {
    position: relative;
    .dot {
      font-size: 18px;
      cursor: pointer;
    }
    .delandreport {
      position: absolute;
      top: 35px;
      width: 102px;
      height: 42px;
      background: #ffffff;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
      color: #333;
      line-height: 42px;
      text-align: center;
      cursor: pointer;
      z-index: 99;
    }
  }
}
.isDisplay {
  justify-content: start;
  p {
    margin-right: 48px;
  }
}
</style>
